export interface SystemConfigSeedNode {
  key: string;
  name: string;
  description?: string;
  children?: readonly SystemConfigSeedNode[];
}

/**
 * Claves de la categoría `GENERAL`, consumidas por el barrido de inactividad
 * (`prospect-inactivity`). Tipadas aquí para que el backend nunca use literales.
 */
export const GENERAL_CONFIG_KEYS = {
  REASSIGN_USER_TIME: 'REASSIGN_USER_TIME',
  TIMEZONE: 'TIMEZONE',
} as const;

export type GeneralConfigKey =
  (typeof GENERAL_CONFIG_KEYS)[keyof typeof GENERAL_CONFIG_KEYS];

/**
 * Claves de la categoría `API_KEYS_LLMS`: la API key de cada proveedor de LLM
 * que el tenant usa para las funcionalidades de IA. Tipadas aquí para que
 * ningún consumidor use literales.
 */
export const LLM_CONFIG_KEYS = {
  ANTHROPIC: 'ANTHROPIC',
  OPEN_AI: 'OPEN_AI',
} as const;

export type LlmConfigKey =
  (typeof LLM_CONFIG_KEYS)[keyof typeof LLM_CONFIG_KEYS];

export const SYSTEM_CONFIG_SEED: readonly SystemConfigSeedNode[] = [
  {
    key: 'META',
    name: 'Meta',
    children: [
      { key: 'META_PIXEL_ID', name: 'Meta Pixel ID' },
      { key: 'META_TOKEN', name: 'Meta Token' },
      { key: 'META_ACCOUNT_ID', name: 'Meta Account ID' },
      { key: 'META_API_VERSION', name: 'Meta API Version' },
      { key: 'META_PIXEL_TOKEN', name: 'Meta Pixel Token' },
      { key: 'META_APP_ID', name: 'Meta App ID' },
      { key: 'META_APP_SECRET', name: 'Meta App Secret' },
      { key: 'META_LOGIN_CONFIG_ID', name: 'Meta Login Config ID' },
      {
        key: 'META_WEBHOOK_VERIFY_TOKEN',
        name: 'Meta Webhook Verify Token (auto-generated on first CoEx channel)',
      },
    ],
  },
  {
    key: 'GENERAL',
    name: 'General',
    children: [
      {
        key: GENERAL_CONFIG_KEYS.REASSIGN_USER_TIME,
        name: 'Dias inactividad prospectos (reasignacion)',
        description:
          'Reasgina prospecto al generente de ventas del grupo por tiempo de inactividad del prospecto',
      },
      {
        key: GENERAL_CONFIG_KEYS.TIMEZONE,
        name: 'Zona horaria',
        description: 'Zona horaria del tenant',
      },
    ],
  },
  {
    key: 'API_KEYS_LLMS',
    name: 'API Keys LLMs',
    description:
      'Credenciales de los proveedores de LLM que usa este tenant. Cada valor es la API key cruda del proveedor.',
    children: [
      {
        key: LLM_CONFIG_KEYS.ANTHROPIC,
        name: 'Anthropic API Key',
        description:
          'API key de Anthropic (Claude) para las funcionalidades de IA de este tenant',
      },
      {
        key: LLM_CONFIG_KEYS.OPEN_AI,
        name: 'OpenAI API Key',
        description:
          'API key de OpenAI para las funcionalidades de IA de este tenant',
      },
    ],
  },
] as const;
